import { flexRender, Table } from '@tanstack/react-table'
import clsx from 'clsx'

import styles from './Table.module.scss'

export const TableHeader = <T,>({ table }: { table: Table<T> }) => {
    return (
        <>
            <thead className={styles.header}>
                {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                            <th
                                className={clsx(styles.headerCell, {
                                    [styles.alignCenterCell]: header.column.columnDef.meta?.alignCenter,
                                })}
                                key={header.id}
                                style={{
                                    width: header.column.columnDef.meta?.width,
                                    maxWidth: header.column.columnDef.meta?.maxWidth,
                                }}
                            >
                                {header.isPlaceholder
                                    ? null
                                    : flexRender(header.column.columnDef.header, header.getContext())}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>

            <tbody>
                <tr className={styles.rowSeparator} />
                <tr className={styles.rowSeparator} />
            </tbody>
        </>
    )
}
